module.exports = __webpack_public_path__ + "static/media/macizo.f484adcc.jpg";